import {
  Req_GetDepartmentList,
  Req_GetTeamerList,
  Req_GetNoDepartPerson,
  Req_DepartAssignList,
  Req_GetCompanyInfo,
  Req_GetProxyAccountList
} from '@/request/organize'

let timer = null
let noDepartTimer = null
let assignTimer = null

export default {
  state: {
    departmentList: [],
    departmentMap: {},
    teamers: [],
    teamerMap: {},
    departAssignList: [],
    noDepartList: [],
    proxyAccountList: [],
    needUpdateProxyAccount: 0
  },
  mutations: {
    changeNUPAstate(state,payload) {
      state.needUpdateProxyAccount = payload
    },
    updateDepartment(state,payload) {
      state.departmentList = payload
      const map = {}
      payload.forEach(item => {
        map[item.id] = item
      })
      state.departmentMap = map
    },
    updateTeamers(state,payload) {
      state.teamers = payload
      const map = {}
      payload.forEach(item => {
        map[item.userId] = item
      })
      state.teamerMap = map
    },
    updateNoDepart(state,payload) {
      state.noDepartList = payload
    },
    initDepartAssign(state,payload) {
      state.departAssignList = payload
    },
    setProxyAccountList(state,payload) {
      state.proxyAccountList = payload
    }
  },
  actions: {
    getProxyAccountList(store) {
      Req_GetProxyAccountList().then(res => {
        store.commit('setProxyAccountList', res)
      }).catch(err => this.$catchErr(err))
    },
    getDepartmentList(store,payload) {
      Req_GetDepartmentList().then(res => {
        store.commit('updateDepartment',res.content)
      }).catch(err => this.$catchErr(err))
    },
    getTeamerList(store,payload) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        Req_GetTeamerList().then(res => {
          store.commit('updateTeamers',res)
        }).catch(err => this.$catchErr(err))
      },10)
    },
    getNoDepartPerson(store,payload) {
      clearTimeout(noDepartTimer)
      noDepartTimer = setTimeout(() => {
        Req_GetNoDepartPerson().then(res => {
          store.commit('updateNoDepart',res)
        }).catch(err => this.$catchErr(err))
      },10)
    },
    getDepartAssignList(store,payload) {
      clearTimeout(assignTimer)
      assignTimer = setTimeout(() => {
        Req_DepartAssignList().then(res => {
          store.commit('initDepartAssign',res)
        }).catch(err => this.$catchErr(err))
      },10)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/organize.js